export default 'settingsPage';
